export default {
  SettingBaseDataLovHeader: {
    name: '名称',
    code: '编码',
    confirmText: '是否继续?',
    sourceText: '没有操作预定义数据的权限',

    table: {
      name: '名称',
      code: '编码',
      source: '来源',
      basicInformation: '基本信息',
      add: '新建值集',
      edit: '编辑值集',
      nameText: '请输入值集名称',
      codeText: '请输入值集编码',
    }
  }
};
